import moment from 'moment'

function twoDigits(d) {
  if (0 <= d && d < 10) return '0' + d.toString()
  if (-10 < d && d < 0) return '-0' + (-1 * d).toString()
  return d.toString()
}

function mySQLDate(date) {
  return (
    date.getUTCFullYear() +
    '-' +
    twoDigits(1 + date.getUTCMonth()) +
    '-' +
    twoDigits(date.getUTCDate()) +
    ' ' +
    twoDigits(date.getUTCHours()) +
    ':' +
    twoDigits(date.getUTCMinutes()) +
    ':' +
    twoDigits(date.getUTCSeconds())
  )
}

// Takes a translation function and a date.
// Returns a string that represents how long ago something happened.
const timeAgoStr = (t, agoDate) => {
  const _c_date = new Date()
  const _s_date = new Date(agoDate)
  const diffTime = Math.abs(_c_date - _s_date)
  const diffSecond = Math.ceil(diffTime / 1000)

  let out = 1 + ' ' + t('sec')

  if (diffSecond < 60) {
    if (diffSecond === 1) {
      out = diffSecond + ' ' + t('sec')
    } else {
      out = diffSecond + ' ' + t('secs')
    }
  } else {
    const diffMin = Math.ceil(diffTime / (1000 * 60))

    if (diffMin < 60) {
      if (diffMin === 1) {
        out = diffMin + ' ' + t('min')
      } else {
        out = diffMin + ' ' + t('mins')
      }
    } else {
      const diffHour = Math.ceil(diffTime / (1000 * 60 * 60))

      if (diffHour < 24) {
        if (diffHour === 1) {
          out = diffHour + ' ' + t('hr')
        } else {
          out = diffHour + ' ' + t('hr')
        }
      } else {
        const diffDay = Math.ceil(diffTime / (1000 * 60 * 60 * 24))

        if (diffDay < 7) {
          if (diffDay === 1) {
            out = diffDay + ' ' + t('day')
          } else {
            out = diffDay + ' ' + t('days')
          }
        } else {
          const diffWeek = Math.ceil(diffTime / (1000 * 60 * 60 * 24 * 7))

          if (diffWeek < 4) {
            if (diffWeek === 1) {
              out = diffWeek + ' ' + t('week')
            } else {
              out = diffWeek + ' ' + t('weeks')
            }
          } else {
            const diffMonth = Math.ceil(diffTime / (1000 * 60 * 60 * 24 * 30))

            if (diffMonth < 12) {
              if (diffMonth === 1) {
                out = diffMonth + ' ' + t('month')
              } else {
                out = diffMonth + ' ' + t('months')
              }
            } else {
              const diffYear = Math.ceil(diffTime / (1000 * 60 * 60 * 24 * 365))

              if (diffYear === 1) {
                out = diffYear + ' ' + t('yr')
              } else {
                out = diffYear + ' ' + t('yrs')
              }
            }
          }
        }
      }
    }
  }

  return out
}

function withinDays(date, days) {
  const sentAt = moment(date, 'YYYY-MM-DD HH:mm:ss')
  return moment().diff(sentAt, 'days') <= days
}

export { mySQLDate, timeAgoStr, withinDays }
